export function getAllowedHostnames(): RegExp[] {
  return [
    /^account-staff\.(test\.|uat\.|staging\.)?spx\.(sg|co\.id|co\.th|vn|ph|com\.my|com\.br)$/,
    /^spx-staff\.business\.accounts\.(test\.|uat\.|staging\.)?shopee\.(sg|co\.id|co\.th|vn|ph|com\.my|com\.br)$/,
  ];
}
